module.exports = __webpack_public_path__ + "static/media/Portrait-10245.163566ce.jpg";